import { useEffect, useCallback, useRef } from 'react';
function getTg() {
    return window.Telegram?.WebApp ?? null;
}
export function useTelegram() {
    const tg = getTg();
    useEffect(() => {
        if (!tg)
            return;
        tg.ready();
        tg.expand();
        updateSafeArea();
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
            tg.requestFullscreen?.();
            tg.disableVerticalSwipes?.();
            setTimeout(updateSafeArea, 300);
            setTimeout(updateSafeArea, 800);
        }
        tg.onEvent('viewportChanged', updateSafeArea);
        tg.onEvent('safeAreaChanged', updateSafeArea);
        tg.onEvent('contentSafeAreaChanged', updateSafeArea);
        return () => {
            tg.offEvent('viewportChanged', updateSafeArea);
            tg.offEvent('safeAreaChanged', updateSafeArea);
            tg.offEvent('contentSafeAreaChanged', updateSafeArea);
        };
    }, []);
    const haptic = useCallback((type = 'success') => {
        tg?.HapticFeedback?.notificationOccurred(type);
    }, []);
    const hapticImpact = useCallback((style = 'light') => {
        tg?.HapticFeedback?.impactOccurred(style);
    }, []);
    return {
        tg,
        initData: tg?.initData ?? '',
        user: tg?.initDataUnsafe?.user ?? null,
        haptic,
        hapticImpact,
    };
}
export function useBackButton(onBack) {
    const tg = getTg();
    const callbackRef = useRef(onBack);
    callbackRef.current = onBack;
    useEffect(() => {
        if (!tg)
            return;
        if (!callbackRef.current) {
            tg.BackButton.hide();
            return;
        }
        const handler = () => callbackRef.current?.();
        tg.BackButton.show();
        tg.BackButton.onClick(handler);
        return () => {
            tg.BackButton.offClick(handler);
            tg.BackButton.hide();
        };
    }, [!!onBack]);
}
function updateSafeArea() {
    const tg = getTg();
    if (!tg)
        return;
    const safeTop = tg.safeAreaInset?.top ?? 0;
    const contentTop = tg.contentSafeAreaInset?.top ?? 0;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const finalTop = Math.max(safeTop + contentTop, isMobile ? 60 : 12);
    document.documentElement.style.setProperty('--tg-top', `${finalTop}px`);
    const safeBottom = tg.safeAreaInset?.bottom ?? 0;
    document.documentElement.style.setProperty('--tg-bottom', `${safeBottom}px`);
}
